import axios from 'axios';
import config from '../config';

const { API_BASE_URL } = config;

class TaskService {
  constructor() {
    this.api = axios.create({
      baseURL: `${API_BASE_URL}/api/v1`,
      withCredentials: true,
    });
  }

  // Set auth token for requests
  setAuthToken(token) {
    this.api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }

  // Get all tasks for logged in user
  async getTasks() {
    try {
      const response = await this.api.get('/getTasks');
      return response.data;
    } catch (error) {
      this.handleError(error);
      throw error;
    }
  }

  // Get task by ID
  async getTaskById(taskId) {
    try {
      const response = await this.api.get(`/tasks/${taskId}`);
      return response.data;
    } catch (error) {
      this.handleError(error);
      throw error;
    }
  }

  // Update task status
  async updateTaskStatus(taskId, status) {
    try {
      const response = await this.api.patch(`/tasks/${taskId}/status`, { status });
      return response.data;
    } catch (error) {
      this.handleError(error);
      throw error;
    }
  }

  // Add note to task
  async addTaskNote(taskId, content) {
    try {
      const response = await this.api.post(`/tasks/${taskId}/notes`, { content });
      return response.data;
    } catch (error) {
      this.handleError(error);
      throw error;
    }
  }

  // Upload attachment to task
  async addTaskAttachment(taskId, file) {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await this.api.post(
        `/tasks/${taskId}/attachments`, 
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
      throw error;
    }
  }

  // Get tasks by status
  async getTasksByStatus(status) {
    try {
      const response = await this.api.get(`/tasks/status/${status}`);
      return response.data;
    } catch (error) {
      this.handleError(error);
      throw error;
    }
  }

  // Error handling helper
  handleError(error) {
    console.error('API Error:', error);
    
    if (error.response) {
      console.error('Error data:', error.response.data);
      console.error('Error status:', error.response.status);
    } else if (error.request) {
      console.error('Error request:', error.request);
    } else {
      console.error('Error message:', error.message);
    }
    
    return {
      message: error.response?.data?.message || error.message || 'An error occurred',
      status: error.response?.status || 500
    };
  }
}

export default new TaskService();